
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class WalletTransaction extends Vue {
  public formTitle = 'تراکنش کیف پول';
  public desserts = [];
  public headers = [
    { text: 'شماره تراکنش', value: 'id' },
    { text: 'نام گروه', value: 'group' },
    { text: 'تاریخ', value: 'transactionDate' },
    { text: 'واریز', value: 'credit' },
    { text: 'برداشت', value: 'debit' },
    { text: 'مانده', value: 'balance' },
    { text: 'توضیحات', value: 'description' },
    { text: '', value: 'action', sortable: false }
  ];
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'گزارش کیف پول',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    await this.updateTransaction();
  }

  async updateTransaction() {
    this.$showLoading();
    await Api.getGroupWallets(parseInt(this.$route.params.id)).then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  async reset() {
    this.$nextTick(async () => {
      await this.updateTransaction();
    });
  }

  async close() {
    await this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
